import { Component, OnInit, inject } from '@angular/core';
import { SiteProxyService } from '../../proxies/asset/site.proxy.service';
import { Site } from '../../models/Site';
import { ModalService } from '@card-software/library';
import { SiteDetailsModalComponent } from '../_modals/site-details-modal/site-details-modal.component';

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrl: './sites.component.scss',
})
export class SitesComponent implements OnInit {
  private readonly siteProxyService = inject(SiteProxyService);
  private readonly modalService = inject(ModalService);

  sites: Site[] = [];
  isLoading = 0;
  ngOnInit() {
    this.isLoading++;
    this.siteProxyService.getSites().subscribe({
      next: (response) => {
        if (response.data) {
          this.sites = response.data;
        }
        this.isLoading--;
      },
      error: (error) => {
        console.error(error);
        this.isLoading--;
      },
    });
  }

  openSiteDetailsModal(site?: Site) {
    this.modalService
      .open(
        SiteDetailsModalComponent,
        { modalClass: 'modal_small' },
        {
          site: site ? site : null,
        },
      )
      .subscribe();
  }
}
